import React, { Fragment } from 'react';
import DocumentTitle from 'react-document-title';

import BenefitsPage from '../components/company/benefits/benefits-page';

const BenefitsRoute = () => (
  <Fragment>
    <DocumentTitle title="Benefits | NerdWallet" />
    <BenefitsPage />
  </Fragment>
);

BenefitsRoute.displayName = 'BenefitsRoute';
BenefitsRoute.analyticsName = 'benefits_page';
BenefitsRoute.segmentPageName = 'benefits';

export default BenefitsRoute;
